module.exports = __webpack_public_path__ + "img/home-bg.9b19679c.png";